import { call } from "redux-saga/effects";
import { APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* getConsentContent(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.CONSENT.GET_CONTENT, null, true);
}

export function* getMerchantConsent(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.CONSENT.GET_MERCHANT, null, true);
}

export function* acceptMerchantConsent(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.CONSENT.ACCEPT_MERCHANT, action.payload, true);
}

export function* getSmsPreference(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.CONSENT.GET_SMS_PREFERENCE, null, true);
}

export function* saveSmsPreference(action: any): any {
    yield call(sagaFunction, action, CallApi.PUT, APIS.CONSENT.SAVE_SMS_PREFERENCE, action.payload, true);
}
